<template>
	<footer>
		&copy; 2020 Sunpacker
	</footer>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style lang="sass">
footer
	padding: 2rem 0
</style>
